export class AccountRecoverModel {
    public email: string;
}
